// import { ResponseException } from '@/shared/rest-api/business/response-exception';
// import { error } from '@/shared/plugins/business/main';
// import { getInstallId } from '@/shared/rest-api/business/env-config';
// import { getClickstreamBaseUrl } from '@/shared/clickstream/config';
// import { UserStore } from '@/shared/store';
// import { AuthSDK } from '@/shared/plugins/business/handle-auth';
// import { clickstreamTracker, EEventKey } from '@/shared/clickstream';
// import { PageType } from '@mm-frontend/frontend-bunseki';
// import { EUiPropertiesSpaceType } from '@mm-frontend/clickstream-client-js';

export class AnalyticAPI {
  public async exposure(experiment: any, result: any): Promise<boolean> {
    try {
      const token = '' //await AuthSDK.getUserToken();

      await fetch(/*getClickstreamBaseUrl()*/ '' + '/api/analytics/v2/experiments/exposure', {
        method: 'POST',
        body: JSON.stringify({
          experiment_id: experiment.key,
          variant_id: result.key,
          exposed_at: new Date().toISOString(),
          account_id: null, //UserStore.getUserRef().value.customerId || null,
        }),
        headers: {
          Authorization: `Bearer ${token}`,
          'X-IID': '', //getInstallId(),
          'Access-Control-Allow-Origin': '*',
          accept: '*/*',
          'Content-Type': 'application/json',
        },
      });

      return true;
    } catch (e) {
      // if (e instanceof ResponseException) {
      //   error(e);
      // } else {
        // error('Что-то пошло не так: ', e);  
      // }
      console.error('Что-то пошло не так: ', e);

      return false;
    }
  }
  public static sendAnalyticsViewCombo(params: any) {
    console.log('Analytics: BUNDLE_VIEW', params);
    // return clickstreamTracker.bundleView({
    //   event: EEventKey.BUNDLE_VIEW,
    //   payload: {
    //     eventParameters: params,
    //     // @ts-ignore
    //     uiProperties: {
    //       space: {
    //         name: PageType.Product,
    //         type: EUiPropertiesSpaceType.PAGE,
    //       },
    //     },
    //   },
    // });
  }
  public static sendAnalyticsClickCombo(params: any) {
    console.log('Analytics: BUNDLE_ADD_TO_CART', params);
    // return clickstreamTracker.bundleAddToCart({
    //   event: EEventKey.BUNDLE_ADD_TO_CART,
    //   payload: {
    //     eventParameters: params,
    //     // @ts-ignore
    //     uiProperties: {
    //       space: {
    //         name: PageType.Product,
    //         type: EUiPropertiesSpaceType.PAGE,
    //       },
    //     },
    //   },
    // });
  }
  public static sendAnalyticsBuyInOneClick(params: any) {
    console.log('Analytics: BUY_IN_ONE_CLICK', params);
    // return clickstreamTracker.BuyInOneClick({
    //   event: EEventKey.BUTTON_CLICKED,
    //   payload: {
    //     eventParameters: params,
    //     // @ts-ignore
    //     uiProperties: {
    //       space: {
    //         name: PageType.Product,
    //         type: EUiPropertiesSpaceType.PAGE,
    //       },
    //     },
    //   },
    // });
  }
  public static sendAnalyticsChangeTabs(params: any) {
    console.log('Analytics: CHANGE_TABS', params);
    // return clickstreamTracker.ChangeTabs({
    //   event: EEventKey.BUTTON_CLICKED,
    //   payload: {
    //     eventParameters: params,
    //     // @ts-ignore
    //     uiProperties: {
    //       space: {
    //         name: PageType.Product,
    //         type: EUiPropertiesSpaceType.PAGE,
    //       },
    //     },
    //   },
    // });
  }

  public static sendAnalyticsViewPopupOtherRewiews(params: any) {
    console.log('Analytics: SHOW_RATING_PARSING_POPUP_PDP', params);
    // return clickstreamTracker.ShowRatingParsingPopupPdp({
    //   event: EEventKey.PAGE_VIEW,
    //   payload: {
    //     eventParameters: params,
    //     // @ts-ignore
    //     uiProperties: {
    //       space: {
    //         // @ts-ignore
    //         name: 'RATING_PARSING_POPUP_PDP',
    //         type: EUiPropertiesSpaceType.MODAL,
    //       },
    //     },
    //   },
    // });
  }
}
